import React, {useCallback, useState} from 'react';
import {Wrapper} from './styles';

const ColoredWrapper = ({ id, className, style, children }) => {
  const [isColored, setIsColored] = useState(false);

  const handleMouseOver = useCallback(() => setIsColored(true), []);
  const handleMouseLeave = useCallback(() => setIsColored(false), []);

  const wrapperClass = `${className} ${isColored ? '' : 'grey'}`;

  return (
    <Wrapper
      id={id}
      className={wrapperClass}
      style={style}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </Wrapper>
  );
};

export default ColoredWrapper;